export default __webpack_public_path__ + "static/media/9 - Sorry Sam.33d8e804.png";